import { IPlatformCohortsResponse, IPlatformFunnelResponse } from '@torim-app/types';
import { platformUrlBuilder, platformFetch } from './utils';

export class AnalyticsApi {
  static async fetchCohorts(months = 6): Promise<IPlatformCohortsResponse> {
    const url = platformUrlBuilder({ months }, 'analytics/cohorts');
    const response = await platformFetch(url);
    if (!response.ok) throw 'Failed to fetch cohorts';
    return response.json();
  }

  static async fetchFunnel(months = 6): Promise<IPlatformFunnelResponse> {
    const url = platformUrlBuilder({ months }, 'analytics/funnel');
    const response = await platformFetch(url);
    if (!response.ok) throw 'Failed to fetch funnel';
    return response.json();
  }
}
